module.exports = __webpack_public_path__ + "img/fantasy.8aa0bdcd.jpg";